export default class RentedMiner {
    minerId = ''
    contractAddress = ''
}
